/* src/app/subcontractor/pages/subcontractor-depot-edit/subcontractor-depot-edit.component.scss */
/*# sourceMappingURL=subcontractor-depot-edit.component.css.map */
